import React, { useState, useEffect } from 'react';
import { api } from '../../utils/api';

export default function AccessLogs() {
  const [logs, setLogs] = useState([]);
  const [stats, setStats] = useState(null);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => { loadData(); }, [page]);

  const loadData = async () => {
    const [logsData, statsData] = await Promise.all([
      api.get(`/logs?page=${page}&limit=20`),
      api.get('/logs/stats').catch(() => null),
    ]);
    setLogs(logsData.logs || []);
    setTotal(logsData.total || 0);
    setStats(statsData);
  };

  const formatDate = (d) => {
    if (!d) return '-';
    return new Date(d).toLocaleString('es-ES', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
  };

  const totalPages = Math.ceil(total / 20);

  return (
    <div>
      {stats && (
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-6">
          <div className="bg-white rounded-xl p-4 shadow-sm text-center">
            <p className="text-2xl font-bold" style={{ color: '#FFB800' }}>{stats.todayAccesses}</p>
            <p className="text-xs text-gray-500">Accesos hoy</p>
          </div>
          <div className="bg-white rounded-xl p-4 shadow-sm text-center">
            <p className="text-2xl font-bold" style={{ color: '#0f1117' }}>{stats.activeUsersLast7Days}</p>
            <p className="text-xs text-gray-500">Usuarios activos (7d)</p>
          </div>
          {stats.topTools?.[0] && (
            <div className="bg-white rounded-xl p-4 shadow-sm text-center col-span-2 sm:col-span-1">
              <p className="text-lg font-bold" style={{ color: '#0f1117' }}>{stats.topTools[0].name}</p>
              <p className="text-xs text-gray-500">Herramienta más usada</p>
            </div>
          )}
        </div>
      )}

      {/* Desktop table */}
      <div className="hidden md:block bg-white rounded-xl shadow-sm overflow-hidden">
        <table className="w-full text-sm">
          <thead style={{ backgroundColor: '#f8f9fa' }}>
            <tr className="text-gray-500 text-xs uppercase">
              <th className="px-4 py-3 text-left">Usuario</th>
              <th className="px-4 py-3 text-left">Herramienta</th>
              <th className="px-4 py-3 text-left">Acción</th>
              <th className="px-4 py-3 text-left">Fecha</th>
              <th className="px-4 py-3 text-left">IP</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {logs.map(l => (
              <tr key={l.id} className="hover:bg-gray-50">
                <td className="px-4 py-3">{l.user_name || '-'}</td>
                <td className="px-4 py-3 text-gray-500">{l.tool_name || '-'}</td>
                <td className="px-4 py-3">
                  <span className="text-xs px-2 py-0.5 rounded" style={{ backgroundColor: '#f1f3f5' }}>{l.action}</span>
                </td>
                <td className="px-4 py-3 text-gray-500">{formatDate(l.created_at)}</td>
                <td className="px-4 py-3 text-gray-400 text-xs">{l.ip_address}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile cards */}
      <div className="md:hidden space-y-2">
        {logs.map(l => (
          <div key={l.id} className="bg-white rounded-lg p-3 shadow-sm">
            <div className="flex justify-between text-sm">
              <span className="font-medium">{l.user_name || '-'}</span>
              <span className="text-xs text-gray-400">{formatDate(l.created_at)}</span>
            </div>
            <div className="flex items-center gap-2 mt-1">
              <span className="text-xs px-2 py-0.5 rounded" style={{ backgroundColor: '#f1f3f5' }}>{l.action}</span>
              {l.tool_name && <span className="text-xs text-gray-500">{l.tool_name}</span>}
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex justify-center gap-2 mt-6">
          <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}
            className="btn-ghost px-4 py-1.5 rounded-lg text-sm disabled:opacity-30">Anterior</button>
          <span className="px-3 py-1.5 text-sm text-gray-500">{page} / {totalPages}</span>
          <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}
            className="btn-ghost px-4 py-1.5 rounded-lg text-sm disabled:opacity-30">Siguiente</button>
        </div>
      )}
    </div>
  );
}
